import React from "react";
import './OurSources.css';

const OurSources = () => {
    return (
        <div className="our-sources">
            <div className="sectiontitle">Our <span>Sources</span></div>
            <div className="sources-container">
                <div className="source-item">
                    <div style={{fontWeight:'500'}}>Embassy/Consulate Resources</div>
                    <ul>
                        <li style={{fontWeight:'500',color:'#321e5d'}}>Your local embassy offers specific visa information and support.</li>
                        <li>
                            <a 
                                href="https://www.usembassy.gov" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                aria-label="Embassy Visa Information"
                            >
                                Official Embassy Portal
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="source-item">
                    <div style={{fontWeight:'500'}}>Visa Application Centers (VACs)</div>
                    <ul>
                        <li style={{fontWeight:'500',color:'#321e5d'}}>Consultants can assist with complex visa applications.</li>
                        <li>
                            <a 
                                href="https://www.vfsglobal.com" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                aria-label="VFS Global"
                            >
                                VFS Global Services
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="source-item">
                    <div style={{fontWeight:'500'}}>Government Websites</div>
                    <ul>
                        <li style={{fontWeight:'500',color:'#321e5d'}}>Get insights from other travelers (verify with official sources).</li>
                        <li>
                            <a 
                                href="https://travel.state.gov" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                aria-label="Official Travel Information"
                            >
                                Official Travel Portal
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default OurSources;